import { CaretDownFilled } from "@ant-design/icons";
import theme from "@/shared/theme";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

import Dropdown from "@/shared/navigation/dropdown";
import Text, { TextProps } from "@/shared/typography/text";
import { useUser } from "@/application/providers/user";
import { useTranslations } from "use-intl";
import { DOCS, PWA_ARTICLE_URL } from "@/shared/external-resourses";

const { useToken } = theme;

export function AccountMenu({
  logout,

  avatar,
}: {
  logout: () => void;

  avatar: ReactNode;
}) {
  const t = useTranslations("AccountMenu");
  const { token } = useToken();
  const user = useUser();

  return (
    <Dropdown
      trigger={["click"]}
      menu={{
        className: "max-w-64",
        items: [
          {
            label: <MenuLink to="/profile">{t("my profile")}</MenuLink>,
            key: "0",
          },
          {
            label: <MenuLink to="/settings">{t("account settings")}</MenuLink>,
            key: "1",
          },
          {
            label: (
              <a href={PWA_ARTICLE_URL} target="_blank" rel="noreferrer">
                <MenuText color={"success"}>
                  {t("Mobile application user guide")}
                </MenuText>
              </a>
            ),
            key: "pwa",
          },
          {
            label: (
              <a href={DOCS} target="_blank" rel="noreferrer">
                <MenuText>{t("help center")}</MenuText>
              </a>
            ),
            key: "2",
          },

          {
            label: (
              <button
                onClick={logout}
                style={{ color: token.colorError }}
                className="w-full text-left"
                data-testid="logout-button"
              >
                <MenuText>{t("log out")}</MenuText>
              </button>
            ),
            key: "3",
          },
        ],
      }}
    >
      <button
        className="flex items-center space-x-1"
        data-testid="account-menu-trigger"
      >
        {avatar}
        <span className="capitalize only-desktop px-3 max-w-40 text-ellipsis whitespace-nowrap overflow-hidden">
          {user?.person?.fullName ?? user?.username}
        </span>
        <CaretDownFilled />
      </button>
    </Dropdown>
  );
}
function MenuLink({ to, children }: { to: string; children: ReactNode }) {
  return (
    <Link to={to}>
      <MenuText>{children}</MenuText>
    </Link>
  );
}

function MenuText(props: TextProps) {
  return <Text type="body2" firstCapitalize color="inherit" {...props} />;
}
